$(document).on(
  "jx1_sinhnhat_19nam_required_popup rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);btn__huongdan
    $(".btn__huongdan").on("click", function (e) {
      $("#popup_reward_wish, #popup_history").removeClass("active");
    });
    $(".popup__close").on("click", function (e) {
      $(".popup").removeClass("active");
    });
  }
);
